"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PercentController = function () {
    function PercentController() {
        'ngInject';

        (0, _classCallCheck3.default)(this, PercentController);
        this.data = [{ "Name": "Item 1", "Percent": 0 }, { "Name": "Item 2", "Percent": 0 }, { "Name": "Item 3", "Percent": 0 }, { "Name": "Item 4", "Percent": 0 }, { "Name": "Item 5", "Percent": 0 }, { "Name": "Item 6", "Percent": 0 }];
        this.checkSummary();
        this.old = angular.copy(this.data);
        this.amount = void 0;
        this.total = void 0;
    }

    (0, _createClass3.default)(PercentController, [{
        key: "createArray",
        value: function createArray(size) {
            this.data = [].concat((0, _toConsumableArray3.default)(Array(size).keys())).map(function (el) {
                return {
                    "Name": "Item 1", "Percent": 0
                };
            });
            console.log(this.data);
            this.checkSummary();
            this.old = angular.copy(this.data);
        }
    }, {
        key: "handleInputChange",
        value: function handleInputChange(index, value) {
            this.data[index]['Percent'] = value;
            this.slider(index);
        }
    }, {
        key: "sliderDown",
        value: function sliderDown(index) {
            this.amount = this.data[index]['Percent'];
        }
    }, {
        key: "slider",
        value: function slider(index) {
            var delta = this.data[index]['Percent'] - (this.amount === void 0 ? this.old[index]['Percent'] : this.amount);
            delta = Math.round(delta * 10000) / 10000;
            // console.log(delta, this.data[index]['Percent'], this.amount);
            if (delta < 0) {
                this.smaller(index, delta);
            } else {
                this.bigger(index, delta);
            }

            this.data.map(function (el) {
                return el['Percent'] = Math.round(el['Percent'] * 10000) / 10000;
            });
            this.data.map(function (el) {
                if (el['Percent'] < 0) {
                    el['Percent'] = 0;
                } else if (el['Percent'] > 10000) {
                    el['Percent'] = 10000;
                }
            });
            this.total = this.data.reduce(function (sum, cur) {
                return sum += cur['Percent'];
            }, 0);
            if (this.data[index]['Percent'] + 10000 - this.total > 0) {
                this.data[index]['Percent'] += 10000 - this.total;
                this.total = 10000;
            }
            if (this.data.some(function (el) {
                return el['Percent'] === 10000;
            })) {
                this.data.map(function (el) {
                    el['Percent'] = el['Percent'] === 10000 ? 10000 : 0;
                });
            }
        }
    }, {
        key: "smaller",
        value: function smaller(index, delta) {
            var smallerVal = Math.min.apply(Math, (0, _toConsumableArray3.default)(this.data.filter(function (_, i) {
                return i !== index;
            }).map(function (e) {
                return e['Percent'];
            })));
            var indexSmallest = this.data.findIndex(function (e) {
                return e['Percent'] === smallerVal;
            });
            this.data[indexSmallest]['Percent'] += Math.abs(delta);
            this.amount += delta;
        }
    }, {
        key: "bigger",
        value: function bigger(index, delta) {
            var _this = this;

            var biggestVal = Math.max.apply(Math, (0, _toConsumableArray3.default)(this.data.filter(function (_, i) {
                return i !== index;
            }).map(function (e) {
                return e['Percent'];
            })));
            var indexBiggest = this.data.findIndex(function (e) {
                return e['Percent'] === biggestVal;
            });
            this.data[indexBiggest]['Percent'] -= delta;
            if (this.data[indexBiggest]['Percent'] < 0) {
                var am = -this.data[indexBiggest]['Percent'];
                this.data[indexBiggest]['Percent'] = 0;
                var distributeAmount = function distributeAmount(unreleatedAmount, index) {
                    if (unreleatedAmount < 1) {
                        return;
                    }
                    var val = Math.max.apply(Math, (0, _toConsumableArray3.default)(_this.data.filter(function (_, i) {
                        return i !== index;
                    }).map(function (e) {
                        return e['Percent'];
                    })));
                    var indVal = _this.data.findIndex(function (e) {
                        return e['Percent'] === val;
                    });
                    _this.data[indVal]['Percent'] -= unreleatedAmount;
                    if (_this.data[indVal]['Percent'] < 0) {
                        unreleatedAmount = -_this.data[indVal]['Percent'];
                        _this.data[indVal]['Percent'] = 0;
                        distributeAmount(unreleatedAmount, index);
                    }
                };
                distributeAmount(am, index);
            }
            this.amount += delta;
        }
    }, {
        key: "handleMouseUp",
        value: function handleMouseUp(index) {
            this.old = angular.copy(this.data);
            this.amount = this.data[index]['Percent'];
        }
    }, {
        key: "checkSummary",
        value: function checkSummary() {
            var delta = 10000 - this.data.reduce(function (sum, cur) {
                return sum += cur['Percent'];
            }, 0);
            if (delta < 0) {
                var biggestVal = Math.max.apply(Math, (0, _toConsumableArray3.default)(this.data.map(function (e) {
                    return e['Percent'];
                })));
                var indexBiggest = this.data.findIndex(function (e) {
                    return e['Percent'] === biggestVal;
                });
                this.data[indexBiggest]['Percent'] += delta;
            }
            var i = 0;
            while (delta > 0) {
                var elDelta = 10000 - this.data[i]['Percent'];
                while (elDelta > 0) {
                    this.data[i]['Percent']++;
                    elDelta--;
                    delta--;
                    if (delta === 0) {
                        return;
                    }
                }
                i++;
            }
            this.data.map(function (el) {
                return el['Percent'] * 100;
            });
        }
    }]);
    return PercentController;
}();

exports.default = PercentController;


// WEBPACK FOOTER //
// ./client/app/components/percent/percent.controller.js